import { render, staticRenderFns } from "./CursorWrap.vue?vue&type=template&id=0a1f030b&scoped=true&"
import script from "./CursorWrap.vue?vue&type=script&lang=js&"
export * from "./CursorWrap.vue?vue&type=script&lang=js&"
import style0 from "./CursorWrap.vue?vue&type=style&index=0&id=0a1f030b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f030b",
  null
  
)

export default component.exports